export const isValidCountryCode = countryCode => {
  const countries = require("../data/countries.json")
  let found = false

  countries.forEach((country, i) => {
    if (country.countryCode === countryCode) {
      found = true
    }
  })

  return found
}
